import { OktaAuth } from "@okta/okta-auth-js";

export const oktaAuth = new OktaAuth({
  issuer: import.meta.env.VITE_OKTA_ISSUER,
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
  redirectUri:
    import.meta.env.VITE_OKTA_REDIRECT_URI ??
    `${window.location.origin}/oauth/okta`,
  // "groups" is required for the groups claim the API checks; offline_access matches marius
  scopes: ["openid", "profile", "email", "groups", "offline_access"],
  pkce: true,
});
